import dayjs from 'dayjs';

export type EventStatus = 'Coming Soon' | 'Ongoing' | 'Closed';

export function getEventStatus(eventStart: string, eventEnd: string): EventStatus {
  const now = dayjs();
  const start = dayjs(eventStart);
  const end = dayjs(eventEnd);

  if (now.isBefore(start)) {
    return 'Coming Soon';
  }

  if (now.isAfter(end)) {
    return 'Closed';
  }

  return 'Ongoing';
}
